import BaseIntegration from '@/common/mixins/integrations/baseIntegration';

const OoredooAlgeriaIntegrationMixin = {
  extends: BaseIntegration,
  methods: {
   getIntegrationParametersCheckImpl() {
      return (to) => {
        if (to.query.user_auth_token && to.query.username) {
          this.proceedToAutoLogin(to);
        } else {
          this.showPage(true);
        }
      };
    },
    getAlternateVerifyPinActionImpl(ti, ts) {
     return () => {
       this.$axios.get(`api/verifyPin?msisdn=${this.registrationInfoMsisdn}&pin=${this.user.pin}&clickid=${this.getClickId}&refUrl=${this.getRefUrl}&campaignId=${this.getCampaignId}&publisherId=${this.getPublisherId}&ti=${ti}&ts=${ts}`).then((response) => {
         const resp = response.data.responseEnum;
         this.waitForResponse = false;
         console.log('loading true');
         this.showLoadingModal = true;
         if (resp === 'OPERATION_SUCCESS') {
           this.$axios.get(`api/getStatus?msisdn=${this.registrationInfoMsisdn}&pin=${this.user.pin}&lang=${this.getLocale}&clickid=${this.getClickId || ''}&refUrl=${this.getRefUrl || ''}&publisherId=${this.getPublisherId || ''}&campaignId=${this.getCampaignId || ''}`).then((res) => {
             this.showLoadingModal = false;
             if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
               const hasSub = res.data.data.isSub;
               if (hasSub === 'true') {
                 this.sendCompleteRegistrationEvent();
               }
               this.storeLoginInfo({
                 token: res.data.data.user_auth_token,
                 rememberMeParameter: false,
                 username: res.data.data.username,
               });
               this.getUserLoginDetails().then(() => {
                 this.updateUserLanguage();
                 this.$router.push('home');
               });
             } else { // error case
               this.$router.push('/');
             }
           });
         } else {
           if (resp === 'PIN_EXPIRED') {
             this.message = 'visitor_sign_up_2_pin_expired';
           } else if (resp === 'WRONG_PIN') {
             this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
           } else if (resp === 'BLOCKED_USER') {
             this.message = 'visitor_forgot_password_warning_msd_max_attempts';
           } else if (resp === 'SERVER_ERROR') {
             this.message = 'home_profile_profile_edit_server_unvailable';
           } else if ((resp === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (resp === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (resp === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
             this.message = 'visitor_sign_up_warning_third_party_error';
           } else if (resp === 'TEST_MSISDN_ACTION_PERFOMED') {
             this.message = 'registration_process_with_test_msisdn_perfomed';
           }
           this.showLoadingModal = false;
           this.hasErrors = true;
         }
       });
     };
    },
  },
};

export default OoredooAlgeriaIntegrationMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/integrations/ooredooAlgeriaIntegration.js